import styled, { css } from 'styled-components'
import { Progress as SemanticProgress } from 'semantic-ui-react'

interface ProgressProps {
  percent: number | string
  size: 'small' | 'regular'
  color: 'green' | 'yellow' | 'orange' | 'blue'
  style: any
}

const Progress = styled(({ size, color, percent, ...rest }: ProgressProps) => {
  const parsedPercent =
    typeof percent === 'string' ? parseInt(percent, 10) : percent

  if (!color && typeof parsedPercent === 'number') {
    if (parsedPercent >= 75) {
      color = 'green'
    } else if (parsedPercent === 0) {
      color = 'orange'
    } else {
      color = 'yellow'
    }
  }

  return <SemanticProgress color={color} percent={percent} {...rest} />
})<ProgressProps>`
  ${({ size }) => css`
    &.ui.progress.blue .bar {
      background: #2a5ef6;
    }

    &.ui.progress .bar {
      min-width: 0%;
      height: ${size === 'small' ? '13px' : '1.75em'};
    }
  `}
`

export default Progress
